export const dashUrl = '/dash/';
export const dashSeoPerformaceUrl = `${dashUrl}seo-performance/`;
